import React, { useState, useEffect } from 'react';

const ScrollToTopButton = ({ targetSelector, threshold = 600, className }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let container = typeof window !== 'undefined' ? window : null;
    let element = null;

    const initContainer = () => {
      if (targetSelector) {
        element = document.querySelector(targetSelector);
        if (element) {
          container = element;
        }
      }
    };

    initContainer();

    const handleScroll = () => {
      // Re-resolve element if not found initially (defensive check)
      if (targetSelector && !element) {
        initContainer();
      }

      const scrollTop = container === window
        ? window.scrollY || document.documentElement.scrollTop
        : (container ? container.scrollTop : 0);

      setVisible(scrollTop > threshold);
    };

    const activeContainer = container || window;
    activeContainer.addEventListener('scroll', handleScroll, { passive: true });
    
    // Fallback polling for dynamically rendered containers
    let pollInterval = null;
    if (targetSelector && !element) {
      pollInterval = setInterval(() => {
        initContainer();
        if (element) {
          clearInterval(pollInterval);
          element.addEventListener('scroll', handleScroll, { passive: true });
          handleScroll();
        }
      }, 100);
    }

    handleScroll();

    return () => {
      activeContainer.removeEventListener('scroll', handleScroll);
      if (element) {
        element.removeEventListener('scroll', handleScroll);
      }
      if (pollInterval) {
        clearInterval(pollInterval);
      }
    };
  }, [targetSelector, threshold]);

  const scrollToTop = () => {
    let container = typeof window !== 'undefined' ? window : null;

    if (targetSelector) {
      const el = document.querySelector(targetSelector);
      if (el) container = el;
    }

    if (!container) return;

    if (container === window) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      container.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  if (!visible) return null;

  return (
    <button
      onClick={scrollToTop}
      aria-label="Scroll to top"
      className={className || "fixed right-4 sm:right-6 bottom-20 sm:bottom-6 z-30 flex items-center justify-center w-10 h-10 sm:w-12 sm:h-12 rounded-full text-white transition-all duration-300 shadow-md border focus:outline-none bg-stone-900/90 hover:bg-stone-800 backdrop-blur-xs border-white/10 hover:scale-105 active:scale-95"}
    >
      <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2.5">
        <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 15.75l7.5-7.5 7.5 7.5" />
      </svg>
    </button>
  );
};

export default ScrollToTopButton;

